import Description from 'components/common/Description'
import Text from './text.json'

const wordLimit = 1600

export default ({ Description: LPDescription, loading, noTitle, descriptionTextHeight = 200, isMobile }) => {
  const isDescriptionLong = LPDescription.length > wordLimit
  return (
    <Description
      title={Text.title}
      Description={LPDescription}
      collapsable={isDescriptionLong}
      noExpand
      loading={loading}
      noTitle={noTitle}
      descriptionTextHeight={descriptionTextHeight}
      isMobile={isMobile}
    />
  )
}
